module.exports = __webpack_public_path__ + "static/media/govtlogo.653e8dbf.png";